import { Check, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

// Renderiza a resposta {ok, steps:[{step,ok,detail}]} das ações de debug.
// Reusado pela coluna de ações e pela seção destrutiva.
export default function StepResultPanel({ result }) {
  const { t } = useTranslation()
  if (!result) return null

  const steps = Array.isArray(result.steps) ? result.steps : []

  return (
    <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-950 p-3 text-xs space-y-1.5">
      <div className="flex items-center gap-1.5 font-medium">
        <span className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-white ${result.ok ? 'bg-status-op' : 'bg-status-down'}`}>
          {result.ok ? <Check size={11} /> : <X size={11} />}
        </span>
        <span className={result.ok ? 'text-status-op' : 'text-status-down'}>
          {result.ok ? t('debug:steps.ok') : t('debug:steps.failed')}
        </span>
      </div>

      {result.error && <p className="text-status-down font-mono pl-5">{result.error}</p>}

      {steps.length > 0 && (
        <ul className="space-y-1 pt-0.5">
          {steps.map((s, i) => (
            <li key={i} className="flex items-start gap-1.5">
              <span className={`mt-[3px] w-1.5 h-1.5 rounded-full shrink-0 ${s.ok ? 'bg-status-op' : 'bg-status-down'}`} />
              <span className="font-mono text-slate-600 dark:text-slate-300">{s.step}</span>
              {s.detail && <span className="text-slate-400 dark:text-slate-500 truncate">· {s.detail}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
